import { Component, OnInit, ViewChild } from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { NgxSpinnerService } from "ngx-spinner";
import { RilrService } from "../services/rilr.service";
import { HelperService } from "../services/helper.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";
import { IOption } from "ng-select";
import { Location } from "@angular/common";

@Component({
  selector: "app-corrective-action-arabian-modal",
  templateUrl: "./corrective-action-arabian-modal.component.html",
  styleUrls: ["./corrective-action-arabian-modal.component.scss"],
  providers: [RilrService],
})
export class CorrectiveActionArabianModalComponent implements OnInit {
  public masterData: any = {};
  public company: Array<IOption> = [];
  public priorityArr: Array<IOption> = [];
  public actionAreaSelectionArr: Array<IOption> = [];
  public criticalFactorList: Array<IOption> = [];
  public fileChanges: boolean = false;
  public attachments: any = [];
  colorTheme = "theme-blue";
  bsConfig: Partial<BsDatepickerConfig>;
  bsValue = new Date();
  public isEdit: number;
  public policyBaseAction: number = 0;
  public areaActionFalse: number = 0;
  public reportID: number;
  public documentSystemID: number;

  public obj_ass_autoId: number; //OBJECTIVE & ASSESSMENT ONLY
  public investiMethod: number;

  public isAITemplate: number;
  aiAreas: any = [
    { value: 1, label: "In Hierarchy of Control - Elimination" },
    { value: 2, label: "Substitution" },
    { value: 3, label: "Engineering Control" },
    { value: 4, label: "Administrative Control" },
    { value: 5, label: "Assurance Action" },
  ];


  @ViewChild("swalModal") swalModal: any;
  @ViewChild("errorMessageHtml") errorMessageHtml: any;
  @ViewChild("errorMessageHtml1") errorMessageHtml1: any;
  @ViewChild("errorMessageHtml2") errorMessageHtml2: any;
  @ViewChild("f") form: any;
  public submitted: boolean = false;
  public isValid: boolean = true;
  public firstDayOfYear: any;
  public successMsg: string = "";
  public htmlErrorMessage: string = "";
  public htmlErrorMessage1: string = 'Title length exceeded.';
  public htmlErrorMessage2: string = 'Employee is required.';
  AssessmentMasterTab2: any = [];

  public employeeOption: Array<IOption> = [];
  public companySystemID = +this.helperService.getSelectedCompanyId();

  yesNoArr: any = [
    { value: 0, label: "Open" },
    { value: 2, label: "Closed" },
  ];

  // icamList: any = [
  //   { value: 1, label: 'Immediate Causes - Unsafe Actions' },
  //   { value: 2, label: 'Immediate Causes - Unsafe Conditions' },
  //   { value: 3, label: 'Underlying Causes' },
  //   { value: 4, label: 'Management System Failures' }
  // ];



  cfList: any = [];
  icamList: any = [];
  scatList: any = [];
  causesIdentifiedList: any = [];

  criticalFactorListRoot: any = [];
  public isCausesIdentified: number;
  public isAnalysisRequired: any;

  constructor(
    public bsModalRef: BsModalRef,
    private rilrService: RilrService,
    private spinner: NgxSpinnerService,
    private helperService: HelperService,
    private location: Location,
    private modalService: BsModalService
  ) {
    this.bsConfig = Object.assign(
      {},
      { containerClass: this.colorTheme, dateInputFormat: "DD/MM/YYYY" }
    );
    this.masterData.IncidateDate = this.bsValue;
  }

  ngOnInit() {
    console.log(this.investiMethod);
    setTimeout(() => {
      if (this.policyBaseAction == 0) {
        this.getFormData();
        this.editFormLoad();
        this.cfList = this.criticalFactorList;
        console.log(this.cfList);
        console.log(this.icamList);
        console.log(this.scatList);
        console.log(this.investiMethod);
        console.log(this.criticalFactorListRoot);
        console.log(this.causesIdentifiedList);
        console.log(this.isAnalysisRequired);
        // this.masterData.actionTitle = this.isCausesIdentified;
        
      }
    }, 0);
  }

  getFormData() {
    const that = this;
    that.rilrService
      .getReportFormData()
      .get({
        companySystemID: that.companySystemID,
        type: "create",
        documentSystemID: that.documentSystemID,
      })
      .subscribe(
        (data) => {
          var resp = data.data.data;
          this.yesNoArr = this.helperService.setSelect2DropDownOptions(
            resp.ticketStatuses,
            "purpose_of_status_id",
            "name"
          );
          this.yesNoArr = this.yesNoArr.filter((s) => s.value != 3);
          if (resp.lastCutOffDate != null) {
            that.firstDayOfYear = new Date(resp.lastCutOffDate);
          }
        },
        (error) => {
          that.spinner.hide();
        }
      );
  }

  

  editFormLoad() { 
    setTimeout(() => {
      if (this.isEdit == 1) {
        this.getEmployees(this.masterData.personResEmpID);
        this.masterData.submitted = this.helperService.setSelectedValue(
          this.masterData.submitted
        );
      }
    }, 0);
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("corrective_action_closed");
  }

  closeSuccessModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason("corrective_action_success");
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  showSuccessHtml() {
    setTimeout(() => {
      this.swalModal.show();
    }, 0);
  }

  public typehead(value: any): void {
    if (value.length > 2) {
      this.getEmployees(value);
    } else {
      this.employeeOption = [];
    }
  }

  getEmployees(value: any) {
    const that = this;
    that.rilrService
      .getTypeheadEmployees()
      .get({
        search: value,
        companySystemID: that.companySystemID,
      })
      .subscribe(
        (resp) => {
          var tempOption = resp.data.data;
          that.employeeOption = [];
          that.employeeOption =
            that.helperService.setSelect2DropDownOptionsConcatLabelThree(
              tempOption,
              "employeeSystemID",
              "empName",
              "countryName",
              "description"
            );
          if (that.isEdit == 1) {
            setTimeout(() => {
              that.masterData.personResEmpSystemID =
                that.helperService.setSelectedValue(
                  that.masterData.personResEmpSystemID
                );
            }, 0);
          }
        },
        (err) => {
          console.log(err);
          that.employeeOption = [];
        }
      );
  }



  public addAttachment(list) {
    this.attachments = list;
    console.log('Current attachments:', this.attachments); 
    this.storeCorrectiveAction();
  }

  public createAction() {
    if (this.form.form.valid) {
      this.submit();
    }
  }

  public submit() {
    // this.storeCorrectiveAction();    //Twise submit corrective action!
    if (!this.submitted) {
     // this.fileChanges = !this.fileChanges;
      this.fileChanges = !this.fileChanges;
      this.storeCorrectiveAction();
    }
  }





  storeCorrectiveAction() {
    const that = this;
    that.isValid = false; 
    that.spinner.show();
    const tempArray = {};
    that.masterData.reportSystemID = that.reportID;
    that.masterData.companySystemID = that.companySystemID;
    that.masterData.documentSystemID = that.documentSystemID;
    that.masterData.policyBaseAction = that.policyBaseAction;
    that.masterData.policyBaseAction = 3;
    that.masterData.host = window.location.origin;
    that.masterData.targetDate = that.helperService.formatDate(
      that.masterData.targetDate
    );
    that.masterData.expectedCompletionDate = that.helperService.formatDate(
      that.masterData.expectedCompletionDate
    );

    that.masterData.obj_ass_autoId = that.obj_ass_autoId; //OBJECTIVE & ASSESSMENT ONLY
    // that.masterData.selectedCauses = that.investiMethod;
 
    if (this.isAnalysisRequired == 1 || this.isAnalysisRequired == '') {
      this.masterData.selectedCauses = 4;
    } else {
      this.masterData.selectedCauses = this.investiMethod;
    }

    this.masterData.actionTitle = this.masterData.actionDescription;
    

    tempArray["master"] = that.masterData;
    tempArray["attachments"] = that.attachments;
    console.log(tempArray);

    if(that.masterData.actionTitle.length > 500){  
      this.errorMessageHtml1.show();
      that.isValid = true;
      that.spinner.hide(); 
    }else if(!that.masterData.personResEmpSystemID){   
        this.errorMessageHtml2.show();
        that.isValid = true;
        that.spinner.hide();  
    }else{
      that.rilrService
        .reportCorrectiveActionsCRUD()
        .post(tempArray)
        .subscribe(
          (resp) => {
            that.masterData = {};
            that.successMsg = "";
            if (that.isEdit === 1) {
              that.successMsg = "Successfully updated corrective action";
            } else if (that.isEdit === 0) {
              that.successMsg = "Successfully added corrective action";
            }
            that.showSuccessHtml();
            that.closeSuccessModal();
            that.spinner.hide();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status === 500) {
              that.isValid = true;
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status === 422) {
              that.isValid = true;
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
            }
            that.spinner.hide();
          }
        );
    }
  }



  


  updateActionTitle() {
    const description = this.masterData.actionDescription;
  
    // Update actionTitle based on the first 100 characters or the first sentence of actionDescription
    const limit = 100;
    const truncatedDescription = description.length > limit ? description.substring(0, limit) : description;
  
    this.masterData.actionTitle = truncatedDescription;
  
    // Alternatively, you can update actionTitle based on the first sentence:
    // const firstSentence = description.split('.')[0];
    // this.masterData.actionTitle = firstSentence;
  }


  
}



// WEBPACK FOOTER //
// /app/src/app/corrective-action-arabian-modal/corrective-action-arabian-modal.component.ts